import React from 'react'
import { css } from 'aphrodite'
import { Link } from 'react-router-dom'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import style from './style'

import TicketTable from './partials/TicketTable'

import SupportView from './SupportView'

import access from '../../utils/access'
import user from '../../utils/user'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('Auth', 'User', 'Ticket', 'Community', 'Config')
@observer
export class Support extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        active: !!props.match.params.id
      },
      search: {
        active: false
      },
      filter: {
        open: false,
        status: -1,
        category: [0],
        date_range: ['2017-06-01', '2017-08-01'],
        modal: 'date_range'
      }
    }
  }

  componentWillMount () {
    const _findTickets = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending || this.props.User.me.pending) {
          return _findTickets()
        }

        Promise.all([
          this.props.Community.getMyCommunities()
            .then(communities => (communities || []))
            .catch(() => []),
          this.props.Ticket.getMyTickets(),
          ...(access.supportAgent(this.props.User.me.permissions)
            ? [this.props.Ticket.getAllTickets()]
            : [])
        ])
          .then(data => {
            const comIdList = data[0].reduce((arr, c) => {
              const userGroups = (this.props.Community.groups[c.id] || [])
                .slice()
                .filter(g => g.users.includes(this.props.Auth.token.userId))
              const userPerms = user.parsePermList({ groups: userGroups })
              if (access.comSupport(userPerms)) {
                return [...arr, c.id]
              }

              return arr
            }, [])

            // if (comIdList.length > 0) {
            return this.props.Ticket.getCommunityTickets(comIdList)
            // }
          })
          .then(() => {
            this.props.User.searchUsers(
              `id:${this.props.Ticket.tickets.all
                .slice()
                .map(t => t.userId)
                .join('|')}`
            )
          })
      }, 500)
    }

    _findTickets()
  }

  setFilterStatus (status) {
    this.setState({
      ...this.state,
      filter: {
        ...this.state.filter,
        status
      }
    })
  }

  setFilterCategory (catId) {
    if (catId === '*') {
      return this.setState({
        ...this.state,
        filter: {
          ...this.state.filter,
          category: [0, 1, 2]
        }
      })
    }

    const _setCatIndex = this.state.filter.category.findIndex(
      cat => cat === catId
    )
    this.setState({
      ...this.state,
      filter: {
        ...this.state.filter,
        category: [
          ...(_setCatIndex > -1
            ? [
              ...this.state.filter.category.slice(0, _setCatIndex),
              ...this.state.filter.category.slice(_setCatIndex + 1)
            ]
            : [...this.state.filter.category, catId])
        ]
      }
    })
  }

  setFilterDateRange (index, value) {
    const dateRange = [
      new Date(this.state.filter.date_range[0]),
      new Date(this.state.filter.date_range[1])
    ]

    dateRange[index].setMonth(dateRange[index].getMonth() + value)

    this.setState({
      ...this.state,
      filter: {
        ...this.state.filter,
        date_range: dateRange
      }
    })
  }

  setFilterModal (type) {
    this.setState({
      ...this.state,
      filter: {
        ...this.state.filter,
        modal: this.state.filter.modal === type ? '' : type
      }
    })
  }

  onTicketClick (ticketId) {
    this.props.history.push(`/dashboard/support/${ticketId}`)
  }

  toggleFilterBox () {
    this.setState({
      ...this.state,
      filter: {
        ...this.state.filter,
        open: !this.state.filter.open
      }
    })
  }

  onSearchInputFocus (e) {
    this.setState({
      ...this.state,
      search: {
        active: true
      }
    })
  }

  onSearchInputFocusOut (e) {
    this.setState({
      ...this.state,
      search: {
        active: false
      }
    })
  }

  render () {
    return (
      <Row>
        <Col
          className={`${
            this.state.editor.active ? `d-none d-lg-block` : `col-12`
          }`}
          lg={this.state.editor.active ? `5` : `12`}
        >
          {this.state.editor.active ? null : (
            <Row className={css(style.top.wrapper)}>
              <Col />
              <Col xs='12' lg={this.state.editor.active ? `12` : `auto`}>
                <Link
                  to={`/dashboard/support/new`}
                  className={css(
                    style.buttons.new,
                    this.state.editor.active ? style.buttons.fullWidth : null
                  )}
                >
                  Create new
                </Link>
              </Col>
            </Row>
          )}
          <Row
            className={css(
              style.table.wrapper,
              style[THEME_LIST[this.props.Config.theme].name]
                ? style[THEME_LIST[this.props.Config.theme].name].table.wrapper
                : null,
              this.state.editor.active ? style.table.wrapperActive : null
            )}
          >
            <Col>
              <TicketTable
                theme={THEME_LIST[this.props.Config.theme]}
                tickets={this.props.Ticket.tickets.all.slice()}
                users={this.props.User.all.slice()}
                filter={this.state.filter}
                isEditorActive={this.state.editor.active}
                setFilterDateRange={this.setFilterDateRange.bind(this)}
                setFilterStatus={this.setFilterStatus.bind(this)}
                setFilterCategory={this.setFilterCategory.bind(this)}
                setFilterModal={this.setFilterModal.bind(this)}
                onTicketClick={this.onTicketClick.bind(this)}
                toggleFilterBox={this.toggleFilterBox.bind(this)}
              />
            </Col>
          </Row>
        </Col>
        {!this.state.editor.active ? null : (
          <Col
            className={`d-flex flex-column ${css(
              style.tickets.wrapper,
              style[THEME_LIST[this.props.Config.theme].name]
                ? style[THEME_LIST[this.props.Config.theme].name].tickets
                    .wrapper
                : null
            )}`}
          >
            <SupportView {...this.props} />
          </Col>
        )}
      </Row>
    )
  }
}

export default Support



// WEBPACK FOOTER //
// ./src/components/Support/index.js